import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useCompanyAdmin } from '../hooks/CompanyAdmin/useCompanyAdmin'
import { useEmployee } from '../hooks/Features/useEmployee'
import { EmployeeContext } from '../context api/Employee/EmployeeContext'
import CustomTableLayout from '../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../hooks/Download/useDownload'
import { getSampleCsvHeadings, formatDate, ROUTES, formatTime } from '../shared/constants'
import { FilterIcon, SortIcon } from '../components/CustomComponents/CustomFilterIcon'
import { ConfigurationContext } from '../context api/Configuration/ConfigurationContext'
import { usePosition } from '../hooks/CompanyConfiguration/usePosition'
import moment from 'moment'
import CustomDialog from '../components/CustomDialog'
import { CustomInput } from '../components/CustomForm'
import CustomButton from '../components/CustomButton'
import axios from 'axios'
import { API } from '../shared/API'
import { toastMessage } from '../shared/AlertPopup'

export default function AllEmployee() {
  const { getAllEmployee, loading, paginate, updateEmployee } = useCompanyAdmin()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { employees, addNewEmployee } = useContext(EmployeeContext)
  const { deleteManyEmployee } = useEmployee()
  const { getAllEmployeeAboveRank6, allEmployeeAboveRank6 } = useCompanyAdmin()
  const { getAllPosition } = usePosition()
  const { positions } = useContext(ConfigurationContext)
  const employeeType = ["INDOOR SALES", "OUTDOOR SALES"];
  const history = useHistory()
  const redirectUrl = 'GET_ALL_EMPLOYEE'
  const [searchQuery, setSearchQuery] = useState('')
  const [modalOpen, setModalOpen] = React.useState(false)
  const [passwordOpen, setPasswordOpen] = React.useState(false)
  const [password, setPassword] = React.useState('')
  console.log({ passwordOpen, password })
  const filterEmployees = employees
  const [filterParams, setFilterParams] = useState({
    page: 1,
    position: [],
    rank: '',
    firstName: 1,
    joiningDate: 1,
    searchQuery,
  })
  console.log({ filterParams })
  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllEmployee({ ...filterParams, searchQuery })
  }, [filterParams?.page, searchQuery])

  useEffect(() => {
    getPdfCsvData(redirectUrl)
  }, [])

  const handleChange = (event, value) => {
    setFilterParams({
      ...filterParams,
      page: value,
    })
  }

  const tempHeaders = getSampleCsvHeadings([
    'employeeCode',
    'firstName',
    'lastName',
    'phoneNumber',
    'employeeType',
    'dob',
    'email',
    'password',
    'rank',
    'positionCode',
    'reportingManagerCode',
    'joiningDate',
    'address',
    'regionCode',
    'zoneCode',
    'stateCode',
    'districtCode',
    'cityCode',
    'storeCode',
  ])
  useEffect(() => {
    getAllPosition()
    getAllEmployeeAboveRank6()
  }, [])

  const handleSwitchChange = (item) => updateEmployee({ ...item, active: !item.active, employeeId: item._id })
  const employeeTypeOptions = [
    { name: 'Indoor Sales', _id: 'INDOOR SALES' },
    { name: 'Outdoor Sales', _id: 'OUTDOOR SALES' },
  ]
  let tableBody = []

  if (!loading && filterEmployees.length > 0) {
    tableBody = filterEmployees.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { image: item.profilePicture, type: 'IMAGE' },
        { value: `${item.firstName} ${item.lastName}` },
        { value: item.position && item.position.positionName },
        { value: item.employeeCode },
        { value: item.employeeType },
        { value: formatDate(item.joiningDate) },
        { value: item.reportingManager && item.reportingManager.firstName },
        { value: item.lastLogin ? moment(item.lastLogin).format('MMMM Do YYYY, h:mm a') : '-----' },
        { type: 'BUTTON', text: 'Change', onClick: () => setPasswordOpen(item.phoneNumber) },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-employee/${item._id}`) },
      ]
    })

    console.log(tableBody)
  }
  const headingOnClick = {
    Name: () => {
      setFilterParams({ ...filterParams, joiningDate: '', firstName: filterParams.firstName === 1 ? -1 : 1 })
    },
    'joining date': () => {
      setFilterParams({ ...filterParams, firstName: '', joiningDate: filterParams.joiningDate === 1 ? -1 : 1 })
    },
    type: () => {
      setModalOpen('employeeType')
    },
    'reporting to': () => {
      setModalOpen('reportingManager')
    },
    position: () => {
      setModalOpen('position')
    },
  }

  const handlePasswordChange = async () => {
    await axios.put(API.UPDATE_PASSWORD_EMPLOYEE, { phoneNumber: passwordOpen, password })
    setPasswordOpen(false)
    return toastMessage('Password Updated Successfully', 'success')
  }
  const layoutProps = {
    heading: 'Manage Employees',
    url: ROUTES.EMPLOYEE,
    editUrl: `/edit-employee/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaders: tempHeaders,
    tempHeaderData: [],
    filename: 'employees',
    sampleName: 'sample_employees',
    sheetName: 'employee',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    redirectUrl,
    addData: addNewEmployee,
    permissionName: 'Employee',
  }
  const modalData = {
    data: modalOpen === 'employeeType' ? employeeTypeOptions : modalOpen === 'position' ? positions : modalOpen === 'reportingManager' ? allEmployeeAboveRank6 : false,
    fieldValue: '_id',
    fieldName: modalOpen === 'position' ? 'positionName' : modalOpen === 'reportingManager' ? 'firstName' : 'name',
  }

  console.log({ modalOpen })
  console.log({ positions })

  return (
    <>
      <CustomDialog open={passwordOpen} handleClose={() => setPasswordOpen(false)}>
        <CustomInput label="Password" fullWidth={true} handleChange={setPassword} value={password} name="password" />
        <br />
        {/* <br /> */}
        <CustomButton text="Update" handleSubmit={handlePasswordChange} />
      </CustomDialog>
      <CustomTableLayout
        tableHeadings={['Image', 'Name', 'position', 'Employee Code', 'type', 'joining date', 'reporting to', 'last login', 'password', 'status', 'info']}
        loading={loading}
        tableBody={tableBody}
        handleSwitchChange={handleSwitchChange}
        handlePageChange={handleChange}
        paginate={{ totalPage: noOfPages, page: filterParams.page }}
        layoutProps={layoutProps}
        checkbox
        deleteMany={(val, setSelected) => deleteManyEmployee({ employeeId: val }, setSelected)}
        headingOnClick={headingOnClick}
        setFilterParams={setFilterParams}
        filterParams={filterParams}
        filterIcons={{
          Name: <SortIcon onClick={headingOnClick.Name} value={filterParams.firstName} />,
          'joining date': <SortIcon onClick={headingOnClick['joining date']} value={filterParams.joiningDate} />,
          type: <FilterIcon onClick={headingOnClick.type} value={filterParams.employeeType} />,
          'reporting to': <FilterIcon onClick={headingOnClick['reporting to']} value={filterParams.reportingManager} />,
          position: <FilterIcon onClick={headingOnClick.position} value={filterParams.position} />,
        }}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalData={modalData}
        permissionName="Employee"
      />
    </>
  )
}
